<!--  -->
<template>
  <div>
    <el-tag v-if="wechatid" style="margin-right:10px">{{ wechatname }}</el-tag>
    <el-button style="margin-bottom:20px" type="primary" size="mini" @click="choosewecaht">选择小程序</el-button>
    <div style="margin-bottom:20px">
      <el-select v-model="value" placeholder="请选择广告位">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div>
      <el-input
        v-model="textarea"
        type="textarea"
        :rows="6"
        placeholder="请输入广告位 ID( 以_(英文下划线)隔开可进行批量添加 )"
      />
    </div>
    <div>
      <el-button style="margin-top:20px" type="primary" size="mini" @click="inbiew">确定</el-button>
    </div>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhosewechat ref="chhosewecahtr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import chhosewechat from './chhosewechat.vue'
import { creatappletsadvlist } from '@/api/officialaccount.js'
export default {
  components: {
    chhosewechat
  },
  data() {
    return {
      wechatname: null,
      wechatid: null,
      dialogVisiblewechat: false,
      options: [{
        value: '1',
        label: 'Banner广告'
      }, {
        value: '2',
        label: '激励广告'
      }, {
        value: '3',
        label: '插屏广告'
      }, {
        value: '4',
        label: '视频广告'
      }, {
        value: '5',
        label: '视频贴片广告'
      }, {
        value: '6',
        label: '格子广告'
      }, {
        value: '7',
        label: '封面广告'
      }, {
        value: '8',
        label: '原生模板广告'
      }],
      value: '',
      textarea: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    async inbiew() {
      if (this.wechatid === null) {
        this.$message.error('请选择小程序')
        return
      }
      if (this.value === '') {
        this.$message.error('请选择广告位')
        return
      }
      if (this.textarea === '') {
        this.$message.error('请输入广告位 ID')
        return
      }
      const data = await creatappletsadvlist({
        mini_program_app_id: this.wechatid,
        ad_id: this.textarea,
        ad_type: this.value
      })
      this.$message({
        message: '创建成功',
        type: 'success'
      })
      this.$emit('close')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
